import { OptionsMenuStorybook } from "@finanedi.es/storybook"
import { faPen } from "@fortawesome/pro-light-svg-icons"
import { PeriodoGetModelo349DtoProps } from "api/DTOs/PeriodoGetModelo349Dto"
import { MODELO_IMPUESTO } from "api/Types/ModeloImpuesto"
import { formatCurrency } from "common/utils/currency"
import { TFunction } from "i18next"
import * as ROUTES from "../../../../../../routes/RoutePaths"
import { TEXTO_TRIMESTRE } from "../../constants/textoTrimestre"
import { RedirectParams } from "../constants"

export const MODELO_349_COLUMNS = (
  t: TFunction,
  navigate: ({ route, periodo, modelo, year }: RedirectParams) => void,
  selectedYear: string
) => {
  const columns = [
    {
      header: `${t("taxSummary.tables.period")}`,
      field: "periodo",
      key: "periodo",
      style: { width: "30%" },
      body: ({ periodo }: PeriodoGetModelo349DtoProps) =>
        periodo ? TEXTO_TRIMESTRE(t)[periodo] : "Total",
    },
    {
      header: `${t("taxSummary.tables.intracomunitarias")}`,
      field: "importe",
      key: "importe",
      alignCol: "right",
      style: { width: "30%" },
      bodyClassName: "!tw-w-auto !tw-text-end",
      body: (rowData: PeriodoGetModelo349DtoProps) => {
        const isRedirect = rowData?.periodo
        return (
          <span
            className={isRedirect ? "!tw-text-info hover:tw-underline" : ""}
            onClick={() =>
              isRedirect &&
              navigate({
                route: `${ROUTES.RESUMEN_IMPUESTOS}/${MODELO_IMPUESTO.MODELO_349}`,
                periodo: rowData?.periodo,
                modelo: MODELO_IMPUESTO.MODELO_349,
                year: selectedYear,
              })
            }
          >
            {formatCurrency(rowData?.iva ?? 0)}
          </span>
        )
      },
    },
    {
      header: `${t("taxSummary.tables.baseImponibleOnly")}`,
      field: "baseImponible",
      key: "baseImponible",
      style: { width: "35%" },
      alignCol: "right",
      bodyClassName: "!tw-w-auto tw-flex tw-justify-end",
      body: (rowData: PeriodoGetModelo349DtoProps) =>
        formatCurrency(rowData?.baseImponible ?? 0),
    },
    {
      key: "buttonActions",
      alignCol: "right",
      header: "",
      style: { width: "4%" },
      className: "tw-text-right !tw-p-2",
      body: (rowData: PeriodoGetModelo349DtoProps) =>
        rowData.periodo ? (
          <div className='tw-w-full tw-flex tw-justify-end [&_*#dropdown-menu-total]:!-tw-top-5 [&_*#dropdown-menu-total]:!tw-right-8'>
            <OptionsMenuStorybook
              id={`${rowData?.periodo ?? "total"}`}
              items={[
                {
                  title: `${t("taxSummary.tables.declaracionButton")}`,
                  icon: faPen,
                  hasRedirect: false,
                  action: () =>
                    navigate({
                      route: ROUTES.DECLARACION_MODELO_349,
                      periodo: rowData?.periodo,
                      modelo: MODELO_IMPUESTO.MODELO_349,
                      year: selectedYear,
                    }),
                },
              ]}
              position='right'
            />
          </div>
        ) : null,
    },
  ]

  return columns
}
